import { useState } from 'react';

export default function BottomCTA() {
  const [liked, setLiked] = useState(false);

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-[#E8E2DA] px-4 py-3 z-50 lg:hidden">
      <div className="flex gap-3">
        <button
          onClick={() => setLiked(!liked)}
          className={`shrink-0 w-12 h-12 rounded-xl border flex items-center justify-center transition-colors active:scale-90 ${
            liked
              ? 'border-red-300 bg-red-50'
              : 'border-[#E8E2DA] bg-[#F7F2EA]'
          }`}
          aria-label={liked ? '찜 해제' : '찜하기'}
        >
          <i
            className={
              liked
                ? 'ri-heart-fill text-red-400 text-lg'
                : 'ri-heart-line text-[#121B35] text-lg'
            }
          />
        </button>
        <button className="flex-1 bg-[#121B35] text-white font-semibold rounded-xl py-3 text-[13px] whitespace-nowrap active:opacity-90 transition-opacity">
          상담 문의하기
        </button>
        {/* <button className="flex-1 bg-[#F7F2EA] text-[#121B35] font-medium rounded-xl py-3 text-[13px] border border-[#E8E2DA] whitespace-nowrap active:bg-[#EDE8E0] transition-colors">
          예약하기
        </button> */}
      </div>
    </div>
  );
}